// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__23TmD","item":"PaymentsMobile_item__3DzwX","label":"PaymentsMobile_label__9GTke","amount":"PaymentsMobile_amount__1Po4t"};